export default "__VITE_ASSET__BXu9UKTR__"